window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
/**
 * This class does a few things:
 * 1. Build the URL for the JSONP layer
 * 2. Split the requests if needed and manage their sending
 * 3. Understand the response, if it's an error or not
 * 4. Set the callback parameter name we expect on the server in this case "cb"
 * {requestObj}
 * Should contain:
 * data - the actual rest request we're going to send in the back end:
 * { u: url for the request
 *   b: the body of the request
 *   m: the method of the request: GET/POST/PUT/DELETE
 *   h: the headers for the request including AUTHORIZTION header }
 * url: the base url to make te request to should be js2rest in the correct domain
 * with sitenumber in the url, example: https://server.iad.liveperson.net/api/account/XXXXXXX/js2rest
 */
lpTag.taglets.rest2jsonp = lpTag.taglets.rest2jsonp || (function () {
    var version = '1.2',
        RESTAPIVersion = "1",
        transportType = "rest2jsonp",
        callCount = 0,
        errorCount = 0,
        pendingCount = 0,
        defaults = {
            retries: 3,
            method: "GET",
            timeout: 30000,
            encoding: "UTF-8",
            callback: "cb"
        },
        baseUrlParts = {
            prefix: "https://",
            middle: "/api/account/",
            suffix: "/js2rest"
        },
        baseUrl = "",
        config = {site: "", domain: ""},
        lpJSONVersion = '1',
        splitRequestUIDLength = 32,
        splitHeaders = {PART_PARAM: 'lpP', OUTOF_PARAM: 'lpO', SECURE_IDENTIFIER: 'lpS'},
        defaultHeaders = {VERSION_PARAM: 'lpV', BODY_PARAM: 'lpB', JSON: 'lpjson', CALLID: 'lpCallId'},
        callIdLength = _createCallId().length,
        maxURLLength = 2083,
        defaultAdditionalLength = _calculateDefaultAdditions(),
        splitAdditionalLength = _calculateSplitAdditions(),
        waitingRequests = {},
        publicAPI;


    function init() {
        if (lpTag && lpTag.taglets && lpTag.taglets.lpAjax) {
            try {
                lpTag.taglets.lpAjax.addTransport(transportType, publicAPI);
            } catch (exc) {}
        }
    }

    /**
     * Set the configuration for this layer
     * Mandatory pieces are site and domain
     * @param configuration
     */
    function configure(configuration) {
        for (var key in configuration) {
            if (configuration.hasOwnProperty(key)) {
                if (defaults.hasOwnProperty(key)) {
                    defaults[key] = configuration[key];
                } else if (config.hasOwnProperty(key)) {
                    config[key] = configuration[key];
                }
            }
        }
        if (config.domain && config.site) {
            baseUrl = baseUrlParts.prefix + config.domain + baseUrlParts.middle + config.site + baseUrlParts.suffix;
        }
    }

    /**
     * Validates the layer can server the request
     * basically this checks for url, success function and that
     * configuration has been set for site and domain
     * @param requestObj
     */
    function isValidRequest(requestObj) {
        var validRequest = false;
        if (requestObj &&
            typeof requestObj.url === 'string' &&
            typeof requestObj.success === 'function' &&
            config.site && config.domain && baseUrl) {
            validRequest = true;
        }
        return validRequest;
    }


    /**
     * The exposed function - decides wether to send a single request or a split one
     * and executes
     */
    function issueCall(requestObj) {
        if (isValidRequest(requestObj)) {
            requestObj = _setRequestObjDefaults(requestObj);
            if (_isMoreThanMaxURLLength(requestObj)) {
                return _splitRequest(requestObj);
            } else {
                return _sendSingleRequest(requestObj);
            }
        } else {
            return false;
        }
    }

    /**
     * Get the transport configuration
     * @returns {{name: string, version: string, callsMade: number, errorsFound: number, pending: number, baseUrl: string, defaults: *}}
     */
    function inspect() {
        return {
            name: transportType,
            version: version,
            callsMade: callCount,
            errorsFound: errorCount,
            pending: pendingCount,
            baseUrl: baseUrl,
            defaults: JSON.parse(_stringify(defaults))
        };
    }

    /**
     * Sets the request defaults so that this layer can handle the request
     * @param requestObj
     */
    function _setRequestObjDefaults(requestObj) {
        for (var key in defaults) {
            if (defaults.hasOwnProperty(key)) {
                requestObj[key] = requestObj[key] || defaults[key];
            }
        }
        requestObj.data = _transformToR2JObject(requestObj);
        requestObj.url = baseUrl + _getSuffixForAppPool(requestObj.data.u);
        return requestObj;
    }

    /**
     * Creates the data type object this layer is expecting
     * @param requestObj
     */
    function _transformToR2JObject(requestObj) {
        return {
            u: _removeJSONSuffix(requestObj.url),
            m: requestObj.method || defaults.method,
            b: requestObj.data || "",
            h: requestObj.headers || ""
        };
    }

    function _removeJSONSuffix(url) {
        if (url && url.indexOf(".json?")) {
            url = url.replace(".json?", "?");
        }
        return url;
    }

    /**
     * Log function to post to lpTag log if it exists
     * @param text
     * @param type
     * @param functionName
     */
    function _log(text, type, functionName) {
        if (lpTag && lpTag.log) {
            lpTag.log(text, type, functionName);
        }
    }

    /**
     * Creates a callId according to the LP convention
     * @return {String} callId
     */
    function _createCallId() {
        return Math.round(Math.random() * 9999999999) + '-' + Math.round(Math.random() * 9999999999);
    }

    /**
     * Transforms the data from JSON into a string and
     * then encodes it so it can be sent as part of a URL
     * @param data
     * @return {String}
     */
    function _encodeData(data) {
        return data ? encodeURIComponent(_stringify(data)) : '';
    }

    /**
     * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
     * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
     * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
     * The function accepts a value and and uses the native JSON.stringify
     * Can throw an exception (same as JSON.stringify).
     */
    function _stringify(value) {
        var stringified;
        if (typeof Array.prototype.toJSON === 'function') {
            var toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    /**
     * Calculates the overhead for each URL string with our default requests
     * @return {Number}
     */
    function _calculateDefaultAdditions() {
        var length = 0;
        for (var key in defaultHeaders) {
            if (defaultHeaders.hasOwnProperty(key)) {
                length += ('&' + defaultHeaders[key] + '=' + '99').length;
            }
        }
        length += version.length + defaults.callback.length + lpJSONVersion.length + callIdLength;
        return length;
    }

    /**
     * Calculates the URL overhead for each request in case of splitting
     * @return {Number}
     */
    function _calculateSplitAdditions() {
        var length = 0;
        for (var key in splitHeaders) {
            if (splitHeaders.hasOwnProperty(key)) {
                length += ('&' + splitHeaders[key] + '=' + '99').length;
            }
        }
        length += 3;//reserved to allow URL addition indicator ! + part
        length += splitRequestUIDLength;
        return length;
    }

    /**
     * Builds the callUrl that we need to send
     * If we only want the base URL we send false in the appendData field
     * @param requestObj - Object
     * @param appendData - Boolean
     * @return {String} - URL
     */
    function _buildCallUrl(requestObj, appendData) {
        var url = requestObj.url + (requestObj.url.indexOf('?') > -1 ? '&' : '?') +
            defaultHeaders.VERSION_PARAM + '=' + RESTAPIVersion + '&' + defaultHeaders.JSON + '=' + lpJSONVersion;
        if (appendData) {
            var data = _encodeData(requestObj.data);
            if (data) {
                url += '&' + defaultHeaders.BODY_PARAM + '=' + data;
            }
        }
        return url;
    }

    /**
     * Checks if the URL on the request complies with JSONP limitations
     * @param requestObj
     * @return {Boolean}
     */
    function _isMoreThanMaxURLLength(requestObj) {
        return (requestObj.url.length + defaultAdditionalLength + _encodeData(requestObj.data).length > maxURLLength);
    }

    /**
     * Runs a callback in a protected way to prevent
     * exceptions and interruptions in the flow
     * @param type - String ERROR/CALLBACK
     * @param callback - Function the actual method to run
     * @param data - Object - the response data for this function
     * @param context - Object - the context for this function
     */
    function _runCallBack(type, callback, data, context) {
        if (typeof  callback === 'function') {
            try {
                callback.call(context || null, data);
            } catch (e) {
                _log("Exception in execution of callback, type :" + type + " e=[" + e.message + "]", "ERROR", "lpTag.JSONP.runCallback");
            }
        } else {
            _log("No callback, of type :" + type, "INFO", "lpTag.JSONP.runCallback");
        }
    }

    /**
     * Builds an object to pass to the JSONP layer
     * @param requestObj - Object - the original object passed in
     * @param retries - the number of retries we want to support
     * @return {Object} - The object we will pass to the JSONP layer
     */
    function _buildInterimRequestObject(requestObj, retries) {
        var interimRequest = {};
        interimRequest.encoding = requestObj.encoding;
        interimRequest.timeout = requestObj.timeout || defaults.timeout;
        interimRequest.callback = requestObj.callback || defaults.callback;
        interimRequest.retries = typeof retries === 'number' ? retries : 0;//No retries on  split requests, this prevents id changes which will ruin the original request
        return interimRequest;
    }

    /**
     * Builds the split requests needed for a long request and starts the sending process
     * @param requestObj
     */
    function _splitRequest(requestObj) {
        requestObj.id = _createCallId();
        waitingRequests[requestObj.id] = {
            originalRequest: requestObj,
            index: 0,
            baseUrl: _buildCallUrl(requestObj, false),
            urls: _buildSplitCallUrls(requestObj.url, _encodeData(requestObj.data), requestObj.id),
            interimObj: _buildInterimRequestObject(requestObj)
        };
        _sendSplitRequest(waitingRequests[requestObj.id].interimObj, waitingRequests[requestObj.id]);
    }

    /**
     * Sends the split requests serially - one after another
     * This method waits for confirmation for any previous request before sending the next one
     * @param interimObj
     * @param waitingRequest
     */
    function _sendSplitRequest(interimObj, waitingRequest) {
        interimObj.url = _buildInterimUrl(waitingRequest);
        interimObj.id = waitingRequest.id + '!' + waitingRequest.index;
        interimObj.success = function (data) {
            if (data && (data.responseCode === 200 || data.responseCode === 201)) {
                if (data && data.lpMeta && data.lpMeta.lpS) {
                    waitingRequest.secureId = data.lpMeta.lpS;
                }
                if ((waitingRequest.index + 1) < waitingRequest.urls.length) {
                    waitingRequest.index++;
                    _sendSplitRequest(interimObj, waitingRequest);
                } else {
                    waitingRequest.originalRequest.success.apply(null, [data]);
                    _cleanUpWaitingRequest(waitingRequest.id);
                }
            } else {
                waitingRequest.originalRequest.error.apply(null, [data]);
                _cleanUpWaitingRequest(waitingRequest.id);
                _incrementErrors();
            }
            _decrementPending();
        };
        interimObj.error = interimObj.success;
        lpTag.taglets.jsonp.issueCall(interimObj);
        _incrementCalls();
    }

    /**
     * Method to send a single request
     * Analyzes the response and fires the correct callback
     * according to the REST protocol in LP
     * @param requestObj
     */
    function _sendSingleRequest(requestObj) {
        var interimObj = _buildInterimRequestObject(requestObj, requestObj.retries || defaults.retries);
        interimObj.id = _createCallId();
        interimObj.url = _buildCallUrl(requestObj, true);
        interimObj.success = function (data) {
            if (data.responseCode && data.responseCode === 200 || data.responseCode === 201) {
                _runCallBack("CALLBACK", requestObj.success, data, requestObj.context);
            } else {
                _runCallBack("ERROR", requestObj.error, data, requestObj.context);
                _incrementErrors();
            }
            interimObj = null;
            requestObj = null;
            _decrementPending();
        };
        interimObj.error = function (data) {
            _runCallBack("ERROR", requestObj.error, data, requestObj.context);
            interimObj = null;
            requestObj = null;
            _decrementPending();
            _incrementErrors();
        };
        lpTag.taglets.jsonp.issueCall(interimObj);
        _incrementCalls();
    }

    /**
     * Cleans up requests we've processed in the
     * split request pool
     * @param requestId
     */
    function _cleanUpWaitingRequest(requestId) {
        waitingRequests[requestId] = null;
        delete waitingRequests[requestId];
    }

    /**
     * Builds the split reqeust URL
     * according to the js2rest convention
     * @param waitingRequest - the waiting request object
     * @return {String}
     */
    function _buildInterimUrl(waitingRequest) {
        return waitingRequest.baseUrl + '&' + splitHeaders.PART_PARAM + '=' + (waitingRequest.index + 1) +
            '&' + splitHeaders.OUTOF_PARAM + '=' + waitingRequest.urls.length +
            (waitingRequest.secureId ? '&' + splitHeaders.SECURE_IDENTIFIER + '=' + waitingRequest.secureId : '' ) +
            '&' + defaultHeaders.BODY_PARAM + '=' + waitingRequest.urls[waitingRequest.index];
    }

    /**
     * Builds the split part URLs
     * @param baseUrl - the base for all the calls
     * @param data - the full data for all the calls
     * @param requestId - the request identifier
     * @return {*}
     */
    function _buildSplitCallUrls(baseUrl, data, requestId) {
        baseUrl += '&' + defaultHeaders.CALLID + '=' + requestId;
        var addedDataFreeLength = maxURLLength - baseUrl.length - splitAdditionalLength - defaultAdditionalLength;//This is unique per request
        return _getSplitParts(addedDataFreeLength, data);
    }

    /**
     * Returns an array of data to append to the base URL
     * in each call to be made in the correct order
     * @param maxLength - the additional length we have for each URL
     * @param data - the data we need to split
     * @return {Array} - an array of the suffixes to the base url
     */
    function _getSplitParts(maxLength, data) {
        var res = '', resArray = [], index;
        var splitsArray = data.split('%');//Split by delimiter that might break the format
        for (index = 0; index < splitsArray.length; index++) {
            if (splitsArray[index].length > maxLength) {//If a single break is greater than the space we have
                splitsArray[index] = _pushFirstPart(res, splitsArray[index], resArray, index, maxLength);//Make sure we utilize the most of each request
                res = '';
                res = _splitText(splitsArray[index], maxLength, resArray);//Split the remaining text into requests
            } else {
                res = _appendToRes(res, splitsArray[index], maxLength, resArray, index);//Append to the existing string
            }
        }
        if (res !== '') {//Make sure we have the request ending
            resArray.push(res);
        }

        function _pushFirstPart(res, text, resArray, index, maxLength) {
            res += index > 0 ? '%' : '';
            var subFirstLength = maxLength - res.length;
            res += text.substring(0, subFirstLength);
            resArray.push(res);
            text = text.substring(subFirstLength, text.length);
            return text;
        }

        function _splitText(text, maxLength, resArray) {
            var count = Math.ceil(text.length / maxLength);
            var subText;
            for (var i = 0; i < count; i++) {
                subText = text.substring(i * maxLength, (i + 1) * maxLength);
                if (i + 1 < count) {
                    resArray.push(subText);
                }
            }
            return subText;
        }

        function _appendToRes(res, newText, maxLength, resArray, index) {
            var resLength = (res + newText).length;
            resLength += (index > 0 ? 1 : 0);
            if (resLength > maxLength) {
                resArray.push(res);
                res = '';
            }
            res += index > 0 ? '%' : '';
            res += newText;
            return res;
        }

        return resArray;
    }

    /**
     * Increments the call counter and pending request counter
     */
    function _incrementCalls() {
        callCount = callCount + 1;
        pendingCount = pendingCount + 1;
    }

    /**
     * Decrements the pending request counter
     */
    function _decrementPending() {
        pendingCount = pendingCount > 0 ? pendingCount - 1 : 0;
    }

    /**
     * Increments the error count
     */
    function _incrementErrors() {
        errorCount = errorCount + 1;
    }

    /**
     * Sets the suffix for the prun to use the correct app pool
     * @param requestUrl
     */
    function _getSuffixForAppPool(requestUrl) {
        var verb = '';
        if (requestUrl.indexOf('/agentSession') != -1) {
            verb = '/agentSession';
        } else if (requestUrl.indexOf('/chat') != -1) {
            verb = '/chat';
        } else if (requestUrl.indexOf('/visit') != -1) {
            verb = '/visit';
            if (requestUrl.indexOf('/keepAlive') != -1) {
                verb += '/keepAlive';
            }
        } else if (requestUrl.indexOf('/configuration') != -1) {
            verb = '/configuration';
        }
        return verb;
    }

    publicAPI = {
        name: transportType,
        version: version,
        init: init,
        configure: configure,
        issueCall: issueCall,
        isValidRequest: isValidRequest,
        inspect: inspect
    };

    init();

    return publicAPI;
})();


/*** EXPORTS FROM exports-loader ***/
module.exports = lpTag.taglets.rest2jsonp;